import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d218798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "teamfoot" }
const _hoisted_2 = {
  key: 0,
  class: "teamfoot-shoufa"
}
const _hoisted_3 = { class: "teamfoot-shoufa-title" }
const _hoisted_4 = { class: "teamfoot-shoufa-name" }
const _hoisted_5 = { class: "teamfoot-shoufa-name-left" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "teamfoot-shoufa-name-right" }
const _hoisted_8 = { class: "teamfoot-shoufa-box" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "teamfoot-shoufa-box-top" }
const _hoisted_11 = {
  class: "teamfoot-shoufa-box-one",
  style: {"justify-content":"space-around","align-items":"center"}
}
const _hoisted_12 = {
  class: "teamfoot-shoufa-box-one-hz",
  style: {"height":"auto"}
}
const _hoisted_13 = { alt: "" }
const _hoisted_14 = { class: "teamfoot-shoufa-box-one" }
const _hoisted_15 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_16 = { alt: "" }
const _hoisted_17 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_18 = { alt: "" }
const _hoisted_19 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_20 = { alt: "" }
const _hoisted_21 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_22 = { alt: "" }
const _hoisted_23 = {
  class: "teamfoot-shoufa-box-one",
  style: {"justify-content":"space-around"}
}
const _hoisted_24 = {
  class: "teamfoot-shoufa-box-one-hz",
  style: {"width":"86px"}
}
const _hoisted_25 = { alt: "" }
const _hoisted_26 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_27 = { alt: "" }
const _hoisted_28 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_29 = { alt: "" }
const _hoisted_30 = {
  class: "teamfoot-shoufa-box-one",
  style: {"height":"25vw"}
}
const _hoisted_31 = { class: "teamfoot-shoufa-box-one-sny" }
const _hoisted_32 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_33 = { alt: "" }
const _hoisted_34 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_35 = { alt: "" }
const _hoisted_36 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_37 = { alt: "" }
const _hoisted_38 = { class: "teamfoot-shoufa-box-bottom" }
const _hoisted_39 = {
  class: "teamfoot-shoufa-box-one",
  style: {"height":"25vw"}
}
const _hoisted_40 = { class: "teamfoot-shoufa-box-one-sny" }
const _hoisted_41 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_42 = { alt: "" }
const _hoisted_43 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_44 = { alt: "" }
const _hoisted_45 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_46 = { alt: "" }
const _hoisted_47 = {
  class: "teamfoot-shoufa-box-one",
  style: {"justify-content":"space-around"}
}
const _hoisted_48 = {
  class: "teamfoot-shoufa-box-one-hz",
  style: {"width":"86px"}
}
const _hoisted_49 = { alt: "" }
const _hoisted_50 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_51 = { alt: "" }
const _hoisted_52 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_53 = { alt: "" }
const _hoisted_54 = { class: "teamfoot-shoufa-box-one" }
const _hoisted_55 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_56 = { alt: "" }
const _hoisted_57 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_58 = { alt: "" }
const _hoisted_59 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_60 = { alt: "" }
const _hoisted_61 = { class: "teamfoot-shoufa-box-one-hz" }
const _hoisted_62 = { alt: "" }
const _hoisted_63 = {
  class: "teamfoot-shoufa-box-one",
  style: {"justify-content":"space-around","align-items":"center"}
}
const _hoisted_64 = {
  class: "teamfoot-shoufa-box-one-hz",
  style: {"height":"auto"}
}
const _hoisted_65 = { alt: "" }
const _hoisted_66 = { class: "teamfoot-shoufa-name" }
const _hoisted_67 = { class: "teamfoot-shoufa-name-left" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "teamfoot-shoufa-name-right" }
const _hoisted_70 = {
  key: 1,
  class: "snjtibu"
}
const _hoisted_71 = { class: "snjtibu-title" }
const _hoisted_72 = { class: "snjtibu-name" }
const _hoisted_73 = { class: "snjtibu-box" }
const _hoisted_74 = { class: "snjtibu-box-cen-sev" }
const _hoisted_75 = { class: "snjtibu-box-cen-sev" }
const _hoisted_76 = { class: "statistics" }
const _hoisted_77 = { class: "statistics-cen" }
const _hoisted_78 = { class: "statistics-title" }
const _hoisted_79 = { class: "statistics-box" }
const _hoisted_80 = { class: "teanback-tab" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "statistics-cen" }
const _hoisted_83 = { class: "statistics-title" }
const _hoisted_84 = { class: "statistics-box" }
const _hoisted_85 = { class: "teanback-tab" }
const _hoisted_86 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.hPlayers && $setup.aPlayers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString($setup.t('me.sfzr')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              ($setup.team1logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.team1logo,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_6))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", null, _toDisplayString($setup.team1), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, "阵型 " + _toDisplayString($setup.data.home_formation), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: $setup.bg,
              alt: "",
              class: "teamfoot-shoufa-box-bg"
            }, null, 8 /* PROPS */, _hoisted_9),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_13, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[0].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[0].name), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_16, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[1].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[1].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_18, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[2].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[2].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_20, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[3].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[3].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_22, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[4].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[4].name), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_25, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[5].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[5].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_27, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[6].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[6].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_29, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan1]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.hPlayers[7].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.hPlayers[7].name), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_33, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan1]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.hPlayers[8].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.hPlayers[8].name), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_35, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan1]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.hPlayers[9].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.hPlayers[9].name), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_37, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan1]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.hPlayers[10].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.hPlayers[10].name), 1 /* TEXT */)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_42, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan2]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.aPlayers[10].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.aPlayers[10].name), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_44, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan2]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.aPlayers[9].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.aPlayers[9].name), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("img", _hoisted_46, null, 512 /* NEED_PATCH */), [
                        [_directive_lazy, $setup.qiuyuan2]
                      ]),
                      _createElementVNode("span", null, _toDisplayString($setup.aPlayers[8].shirt_number), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString($setup.aPlayers[8].name), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_49, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[7].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[7].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_51, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[6].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[6].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_53, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[5].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[5].name), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_56, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[4].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[4].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_58, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[3].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[3].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_60, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[2].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[2].name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_62, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[1].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[1].name), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", _hoisted_65, null, 512 /* NEED_PATCH */), [
                      [_directive_lazy, $setup.qiuyuan2]
                    ]),
                    _createElementVNode("span", null, _toDisplayString($setup.aPlayers[0].shirt_number), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, _toDisplayString($setup.aPlayers[0].name), 1 /* TEXT */)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              ($setup.team1logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.team2logo,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_68))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", null, _toDisplayString($setup.team2), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("span", null, _toDisplayString($setup.t('me.zx')) + " " + _toDisplayString($setup.data.away_formation), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.hPlayers && $setup.aPlayers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
          _createElementVNode("p", _hoisted_71, _toDisplayString($setup.t('me.tbzr')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("p", null, _toDisplayString($setup.team1), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString($setup.team2), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_73, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tbPlayer, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "snjtibu-box-cen",
                key: i
              }, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("span", null, _toDisplayString($setup.tbHomePlayers[i] ? $setup.tbHomePlayers[i].shirt_number : ""), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.tbHomePlayers[i] ? $setup.tbHomePlayers[i].name : ""), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("span", null, _toDisplayString($setup.tbAwayPlayers[i] ? $setup.tbAwayPlayers[i].shirt_number : ""), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.tbAwayPlayers[i] ? $setup.tbAwayPlayers[i].name : ""), 1 /* TEXT */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.$t('play.teamUserTj') + "-" + $setup.team1), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footballtongji, (item, index) => {
                    return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              ($setup.homePlayers)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.homePlayers, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.name ? item.name : item.player_id), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.first == "1" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.start == "0" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.goals), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.penalty), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.assists), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.minutes_played), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.red_cards), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.yellow_cards), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.shots), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.shots_on_target), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dribble), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dribble_succ), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.clearances), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.blocked_shots), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.interceptions), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.tackles), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.passes), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.passes_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.crosses), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.crosses_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.long_balls), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.long_balls_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.duels), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.duels_won), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dispossessed), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.fouls), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.was_fouled), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.saves), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.punches), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.runs_out), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.runs_out_succ), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.good_high_claim), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.$t('play.teamUserTj') + "-" + $setup.team2), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.footballtongji, (item, index) => {
                    return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              ($setup.awayPlayers)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_86, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.awayPlayers, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.name ? item.name : item.player_id), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.first == "1" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.start == "0" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.goals), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.penalty), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.assists), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.minutes_played), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.red_cards), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.yellow_cards), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.shots), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.shots_on_target), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dribble), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dribble_succ), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.clearances), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.blocked_shots), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.interceptions), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.tackles), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.passes), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.passes_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.crosses), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.crosses_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.long_balls), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.long_balls_accuracy), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.duels), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.duels_won), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.dispossessed), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.fouls), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.was_fouled), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.saves), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.punches), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.runs_out), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.runs_out_succ), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(item.good_high_claim), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}